import React from "react";
import { Link } from "react-router-dom";
import { Home, TrainFront } from "lucide-react";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <section className="min-h-[70vh] flex items-center justify-center bg-slate-50">
      <Seo title="Page not found" path="/404" noindex />
      <div className="max-w-md mx-auto text-center px-6">
        <TrainFront className="w-14 h-14 text-[#E63B2E] mx-auto mb-5" />
        <p className="tdf-heading text-6xl text-tdf-navy">404</p>
        <p className="text-slate-600 mt-3 mb-8">
          This page has been diverted. Let&rsquo;s get you back on track.
        </p>
        <Link to="/" className="btn-pill btn-primary">
          <Home className="w-4 h-4" /> Back to Home
        </Link>
      </div>
    </section>
  );
}
